module.exports = __webpack_public_path__ + "static/media/b2_p12_clickable.94c003c0.png";